import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import * as Icons from '../../../Global/Icons';

class ControlButton extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isHover: false,
		};

		this.getMessage = this.getMessage.bind(this);
		this.setHoverOn = this.setHoverOn.bind(this);
		this.setHoverOff = this.setHoverOff.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	getMessage() {
		if (this.props.isActive) {
			return null;
		}

		if (this.props.hasNotification && this.props.notificationMessage) {
			return <div className="control-button__message">{this.props.notificationMessage}</div>;
		}

		if ((this.props.persistLabel && this.props.label) || (this.state.isHover && this.props.label)) {
			return <div className="control-button__message">{this.props.label}</div>;
		}

		return null;
	}

	setHoverOn() {
		this.setState({ isHover: true });
	}

	setHoverOff() {
		this.setState({ isHover: false });
	}

	handleClick() {
		if (this.props.callback) {
			this.props.callback();
		}

		this.setHoverOff();
	}

	render() {
		const thisClassName = this.props.shuffle ? 'shuffle' : this.props.className;
		const Icon = Icons[this.props.iconName];
		const Badge = Icons.Badge;

		const classes = classnames('control-button', {
			[`control-button--${thisClassName}`]: Boolean(thisClassName),
			'control-button--is-active': this.props.isActive,
			'control-button--has-notification': this.props.hasNotification,
			'control-button--no-interaction': !this.props.callback,
			'control-button--reverse-flow': this.props.reverseFlow,
		});

		return (
			<div
				className={classes}
				onMouseEnter={this.setHoverOn}
				onMouseLeave={this.setHoverOff}
				onClick={this.handleClick}
			>
				<div className="control-button__icon">
					<Icon />
					<Badge classes="badge" />
				</div>
				{this.getMessage()}
			</div>
		);
	}
}

ControlButton.propTypes = {
	shuffle: PropTypes.bool,
	className: PropTypes.string,
	iconName: PropTypes.string,
	isActive: PropTypes.bool,
	persistLabel: PropTypes.bool,
	hasNotification: PropTypes.bool,
	notificationMessage: PropTypes.node,
	label: PropTypes.node,
	callback: PropTypes.func,
	reverseFlow: PropTypes.bool,
};

ControlButton.defaultProps = {
	shuffle: false,
	className: null,
	iconName: 'ShuffleIcon',
	isActive: false,
	persistLabel: false,
	hasNotification: false,
	notificationMessage: '',
	label: '',
	callback: () => null,
	reverseFlow: false,
};

export default ControlButton;



// WEBPACK FOOTER //
// ./src/components/Extension/Shared/ControlButton/index.js